<div class="container">
  <fgb-member-card [wallet]="true"></fgb-member-card>

  <div class="d-lg-block d-none mt-lg-3 mt-4 mb-0">
    <fgb-home-nav></fgb-home-nav>
  </div>
</div>

<ng-container *ngIf="walletItems?.length > 0; else noWalletItems">
  <div class="wallet-redeem-carousel pt-lg-4 pt-0">
    <div class="container">
      <fgbcl-rewards-wallet-redeem-list [unRedeemedItems]="walletItems"></fgbcl-rewards-wallet-redeem-list>
    </div>
  </div>
</ng-container>

<ng-template #noWalletItems>
  <div class="container">
    <h5 class="no-wallet-items mt-5 mb-3 fw-bold">{{ 'rewards.wallet.no.items' | translate }}</h5>
    <div class="no-wallet-items-description font-praktika-bold border rounded font-size-12 text-center bg-primary py-3">
      {{ 'rewards.wallet.no.items.description' | translate }}
    </div>
  </div>
</ng-template>

<div class="container mt-3 text-center mb-5">
  <div class="claimed-button border border-secondary">
    <div class="claimed-button-text">
      <h5 class="mb-1">{{ 'wallet.claimed.rewards' | translate }}</h5>
      <div class="font-praktika-normal font-size-14">{{ 'wallet.claimed.rewards.history' | translate }}</div>
    </div>
    <a
      class="font-praktika-bold font-size-14 claimed-text fw-bold btn btn-secondary border-secondary rounded text-white"
      [routerLink]="['/rewards/claimed']"
    >
      {{ 'view.claimed.rewards' | translate }}
    </a>
  </div>
</div>
